module.exports = __webpack_public_path__ + "img/cover.2aa57934.jpg";